import { createGlobalState } from 'react-use';

import { VisitStatus } from '@dreryk/egabinet-visit-frontend-api';

type VisitId = number;
type VisitStatusState = Array<[VisitId, VisitStatus | null]>;

type VisitStatusGetter = (visitId: VisitId | undefined) => VisitStatus | null | undefined;
type VisitStatusUpdater = (newState: VisitStatusState) => void;
type VisitStatusReset = VoidFunction;

const useGlobalState = createGlobalState(new Map<VisitId, VisitStatus | null>());

type UseVisitStatusGlobalStateReturnFn = {
   getStatus: VisitStatusGetter;
   updateStatus: VisitStatusUpdater;
   resetStatus: VisitStatusReset;
};

export const useVisitStatusGlobalState = (): UseVisitStatusGlobalStateReturnFn => {
   const [globalState, setGlobalState] = useGlobalState();

   const getStatus: VisitStatusGetter = (visitId) => {
      if (visitId === undefined) {
         return undefined;
      }
      return globalState.get(visitId) ?? undefined;
   };

   const resetStatus: VisitStatusReset = () => {
      setGlobalState(new Map());
   };

   const updateStatus: VisitStatusUpdater = (newState) => {
      setGlobalState(new Map([...globalState, ...newState]));
   };

   return {
      getStatus: getStatus,
      updateStatus: updateStatus,
      resetStatus: resetStatus,
   };
};
